import React, { ReactNode } from "react";

type CalloutType = "note" | "warning" | "tip" | "error";

interface DocsCalloutProps {
  children: ReactNode;
  type?: CalloutType;
  title?: string;
}

const DocsCallout = ({
  children,
  type = "note",
  title
}: DocsCalloutProps) => {
  return (
    <div className="my-8 rounded-lg border border-[#eaeaea] bg-[#fafafa] p-6 text-sm leading-relaxed text-slate-600">
      <span className="mr-1 font-bold text-black">
        {title || (type === "warning" ? "Warning:" : "Good to know:") }
      </span>
      {children}
    </div>
  );
};

export default DocsCallout;
